import { Component, TemplateRef, ViewChild } from '@angular/core';
import { AddCooperativesComponent } from '../add-cooperatives/add-cooperatives.component';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { RouterModule } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateCooperativeComponent } from '../update-cooperative/update-cooperative.component';

@Component({
  selector: 'app-list-cooperatives',
  templateUrl: './list-cooperatives.component.html',
  styleUrl: './list-cooperatives.component.scss'
})

export class ListCooperativesComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  statut: any = '';
  isDisabled: boolean = false;
  hasError = false;
  errorMessage = '';
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  visible: boolean = false;
  adminItems: any = [];


  constructor(

    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService,



  ) {
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getCooperative();
    });
  }

  ngOnInit() {
    this.user_reference = this.localstorage.getUsers().data.reference;
     console.log("this.user_reference", this.user_reference);
  }


  getCooperative() {
    this.isLoading = true;
    this.hasError = false;

    this.paramService.getCooperative().subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();
        this.getAdministrateur();
        //console.log("la reponse du webservice", this.items);

      },
      (error) => {
        //console.log("une erreu est survenu", error);
        this.isLoading = false;
        this.hasError = true;
        this.errorMessage = 'Impossible de charger les données';
      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }
  openModal() {
    this.modalService.open(AddCooperativesComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  editOpenModal(item: any) {
    this.localstorage.saveCooperative(item);
    this.modalService.open(UpdateCooperativeComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  confirmSuppression(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir supprimer cette coopérative?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass: 'p-button-danger', // Style pour le bouton "Oui" (rouge)
      rejectButtonStyleClass: 'p-button-text p-button-primary', // Style pour le bouton "Non" (bleu)
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        const requestData = {
          cooperative_id: event.reference,
          user_id: this.user_reference
        }
        this.paramService.deleteCooperative(requestData).subscribe(
          (response: any) => {
            // console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });
            this.getCooperative();
            this.ngxService.stop();

          },
          (error) => {
            this.ngxService.stop();

            // console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error });


          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: Constant.rechercheiTitle, detail: 'Vous avez rejeté', life: 3000 });
      // }
    });
  }
  getAdministrateur() {
    this.authService.getAdministrateur(this.user_reference).subscribe(
      (response: any) => {
        this.adminItems = response.data;
        console.log('la reponse du  webservice', this.adminItems);

      },
      (error: any) => {
        console.log("une erreur est survenu", error);

      }
    )
  }

  itemSelected: any;
  selectedAdmin: any;
  addAdministrateurToCooperative(item: any) {
    console.log("item",item);

    this.itemSelected = item;
    this.visible = true;
  }

  saveAdminToCooperative() {
    if (!this.selectedAdmin) {
      this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: "L'administrateur est obligatoire" });
      return
    }
    const requestData = {
      admin_id:  this.selectedAdmin,
      cooperative_id:this.itemSelected.reference
    }
    this.ngxService.start();
    this.authService.addAdministrateurToCooperative(requestData).subscribe(
      (response: any) => {
        this.adminItems = response.data;
        this.visible = false;
        this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });

        console.log('la reponse du  webservice', this.adminItems);
        this.ngxService.stop();

      },
      (error: any) => {
        console.log("une erreur est survenu", error);
        this.visible = true;
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error });

      }
    )
  }
}
